import { useMonolithQuery } from '@zorro/web/ui-utils';
import _noop from 'lodash/noop';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type BulkApplicationContextProps = {
  onboardingPeriodIds: string[];
  setOnboardingPeriodIds: Dispatch<SetStateAction<string[]>>;
};

export const BulkApplicationContext =
  createContext<BulkApplicationContextProps>({
    onboardingPeriodIds: [],
    setOnboardingPeriodIds: _noop,
  });

type Props = {
  children?: ReactNode;
};

export const BulkApplicationContextProvider = ({ children }: Props) => {
  const [onboardingPeriodIds, setOnboardingPeriodIds] = useState<string[]>([]);
  return (
    <BulkApplicationContext.Provider
      value={{ onboardingPeriodIds, setOnboardingPeriodIds }}
    >
      {children}
    </BulkApplicationContext.Provider>
  );
};

export function useBulkApplication() {
  const { onboardingPeriodIds, ...ctx } = useContext(BulkApplicationContext);

  const { data: enrollmentSummary } = useMonolithQuery({
    method: 'enrollmentReportsControllerGenerateEnrollmentSummary',
    params: onboardingPeriodIds.length > 0 && [{ onboardingPeriodIds }],
  });

  return { ...ctx, enrollmentSummary, onboardingPeriodIds };
}
